/**
 * Duration (in milliseconds) of warning before session timeout
 * @see https://dev.azure.com/KHTechnologySolutions/Decision%20Support%20Tool/_workitems/edit/5406/
 */
export const SESSION_WARNING_COUNTDOWN_MS = 2 * 60 * 1000;

/**
 * Default duration (in milliseconds) that a session can be idle before timing out
 * @see https://dev.azure.com/KHTechnologySolutions/Decision%20Support%20Tool/_workitems/edit/5406/
 */
export const SESSION_IDLE_MS_DEFAULT =
  25 * 60 * 1000 + SESSION_WARNING_COUNTDOWN_MS;

/**
 * Storage event Key for broadcasting activity timestamp across tabs.
 * @see https://dev.azure.com/KHTechnologySolutions/Decision%20Support%20Tool/_workitems/edit/5406/
 */
export const ACTIVITY_BROADCAST_KEY = 'aa:activity:ts';
